import { Link } from "react-router-dom";
import { CalendarCheck, ClipboardList, LayoutGrid, Truck } from "lucide-react";
import { SidebarShell } from "@/components/layout/SidebarShell";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useSession } from "@/lib/session/SessionContext";
import { usesMobileApp } from "@shared/roles.js";

/**
 * Startseite für Mandanten-Mitglieder (Akteurstyp „member"). Sie war die
 * einzige Navigation der App — vier Schaltflächen, über die jeder Weg lief.
 * Seit der Seitenleiste ist sie das nicht mehr: die Wege stehen links
 * (AppSidebar.tsx), hier steht nur noch ein Einstieg für den ersten Blick.
 *
 * Wer eine Mobile-Lizenz trägt, kommt nach dem Login gar nicht hier an
 * (lib/session/homeRoute.ts), sondern direkt auf seinem Tag — der Verweis
 * darauf bleibt trotzdem, für den Weg zurück über das Logo.
 */
export function AppHomePage() {
  const { session } = useSession();
  const role = session?.actorType === "member" ? session.role : null;

  const einstiege = [...(role && usesMobileApp(role) ? [{ to: "/app/heute", icon: CalendarCheck, titel: "Mein Tag", text: "Die Aufträge, die heute auf dich warten." }] : []), { to: "/app/dispo", icon: LayoutGrid, titel: "Dispoboard", text: "Der Tag als Bildschirm — wer fährt was, und wann." }, { to: "/app/auftraege", icon: ClipboardList, titel: "Aufträge", text: "Anlegen, suchen, nachsehen, abrechnen." }, { to: "/app/stammdaten/fahrzeuge", icon: Truck, titel: "Stammdaten", text: "Fahrzeuge, Auftragsarten, Adressen, Ressourcen, Teams." }];

  return (
    <SidebarShell title="Start" maxWidth="max-w-4xl">
      <div className="flex flex-col gap-6">
        <p className="text-sm text-muted-foreground">Angemeldet als Mitglied{role ? ` (Rolle: ${role})` : ""}.</p>

        <div className="grid gap-4 sm:grid-cols-2">
          {einstiege.map((einstieg) => (
            // Die ganze Karte ist der Link: ein Ziel, ein Tabstopp.
            <Link key={einstieg.to} to={einstieg.to} className="rounded-lg outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
              <Card className="h-full transition-colors hover:border-primary">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <einstieg.icon className="size-4" aria-hidden="true" />
                    {einstieg.titel}
                  </CardTitle>
                  <CardDescription>{einstieg.text}</CardDescription>
                </CardHeader>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </SidebarShell>
  );
}
